module.exports = __webpack_public_path__ + "h5/img/wuzhou1@2x.a6583db4.png";